<template>
    <footer class="footer footer-big footer-white">
        <div class="container">
            <ul class="pull-left">
                <li>
                    <a href="/">
                        Home
                    </a>
                </li>
                <li>
                    <a href="/services">
                        Services
                    </a>
                </li>
                <!-- <li>
                    <a href="/aboutus">
                        About Us
                    </a>
                </li> -->
                <li>
                    <a href="/contactus">
                        Contact Us
                    </a>
                </li>
            </ul>
            <span class="copyright">
                <a href="/img/jgestates-compliance.jpg" target="_blank">
                    Property Redress Scheme
                </a>
            </span>
            <span id="span-separator">|</span>
            <span class="copyright">
                <a href="/img/jgestates-ico.jpg" target="_blank">
                    Information Commissioners Office (ICO)
                </a>
            </span>
            <span class="copyright"></span>
            <div class=" copyright pull-right">
                Copyright &copy;
                {{year}}
                JG Estates
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style>

#span-separator {
    margin: 0 5px;
}

</style>
